import { gql } from '../../../__generated__/graphql/catalog'

export const CREATE_PRODUCT_REVIEW = gql(`
  mutation CreateProductReview($review: ReviewInput!) {
    createReview(review: $review)
  }
`)
